import FilterItem from "./FilterItem.vue";
import SellerFilterBody from "./bodies/SellerFilterBody.vue";
import { truncateString } from "@/utils";
export default {
  name: "SellerFilter",
  components: {
    FilterItem,
    SellerFilterBody
  },
  emits: ["apply", "cleared"],
  props: {
    sellers: {
      type: Object,
      required: true,
      default: () => ({
        filterState: {
          selected: [],
          list: []
        },
        isModified: false,
        select: () => {},
        deselect: () => {},
        clear: () => {},
        apply: () => {},
        listSearch: () => {}
      })
    },
    onlyMode: {
      type: Boolean,
      default: false
    },
    select_key: {
      type: String,
      default: "id"
    },
    search_key: {
      type: Array,
      default: ["name", "id", "region"]
    },
    no_reset: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    getSellerJoined() {
      return this.sellers.selected?.map(seller => seller.name !== "" ? seller.name : seller.id).join(", ");
    },
    getSellerTitle() {
      return this.getSellerJoined ? truncateString(this.getSellerJoined, 20) : "All Sellers";
    },
    getSellerSelectedTitle() {
      return this.getSellerJoined ? truncateString(this.getSellerJoined, 200) : "";
    }
  },
  methods: {
    onSelect($event) {
      if (this.onlyMode) {
        this.sellers.selectOnly($event, this.select_key);
      } else {
        this.sellers.select($event, this.select_key);
      }
    },
    onSelectOnly($event) {
      this.sellers.selectOnly($event, this.select_key);
    },
    onDeSelect($event) {
      this.sellers.deselect($event, this.select_key);
      if (this.sellers?.filterState?.selected.length === 0) {
        this.$emit("cleared");
      }
    },
    onClear() {
      this.sellers.clear();
      this.$emit("cleared");
    },
    onDiscard() {
      // Discard button: revert the pending changes to the last-applied
      // selection. The applied state is unchanged, so we do not emit/refresh.
      this.sellers.clearDraft();
    },
    onHidden() {
      this.sellers.clearDraft();
    },
    onRestoreSearch() {
      this.sellers.restoreSearch();
    },
    onApply() {
      this.$emit("apply");
    },
    onClose() {
      this.$refs?.sellerFilterItem?.closeDropdown();
    },
    onSearch($event) {
      this.sellers.listSearch($event.value, [...this.search_key, "id"]);
    }
  }
};